const logger = require('utilities/logger');

let shadowGuid = 0;

const getShadowGuid = () => {
	return shadowGuid++;
};

const copyCSSToShadow = el => {
	const shadowElem = document.getElementById(el.dataset.shadowElemId);
	const styles = getComputedStyle(el);

	shadowElem.style.fontFamily = styles.fontFamily;
	shadowElem.style.fontSize = styles.fontSize;
	shadowElem.style.width = styles.width;
	shadowElem.style.padding = styles.padding;
	shadowElem.style.lineHeight = styles.lineHeight;
	shadowElem.style.whiteSpace = 'pre-wrap';
	shadowElem.style.overflowWrap = 'break-word';
};

module.exports = {
	bind(el) {
		const guid = getShadowGuid();
		const shadowElemWrapper = document.createElement('div');
		const shadowElemWrapperId = `shadow-element-wrapper-${guid}`;

		shadowElemWrapper.id = shadowElemWrapperId;
		shadowElemWrapper.classList.add('v-autosize-textarea-helper');
		shadowElemWrapper.style.width = 0;
		shadowElemWrapper.style.height = 0;
		shadowElemWrapper.style.overflow = 'hidden';

		el.dataset.shadowElemWrapperId = shadowElemWrapperId;

		document.body.appendChild(shadowElemWrapper);

		const shadowElem = document.createElement('div');
		const shadowElemId = `shadow-element-${guid}`;
		shadowElem.id = shadowElemId;
		el.dataset.shadowElemId = shadowElemId;

		shadowElemWrapper.appendChild(shadowElem);

		copyCSSToShadow(el);

		el.style.overflow = 'hidden';
	},
	update(el, { value }) {
		if ($(el).width() < 10) {
			logger.info('Textarea with autosize must have explicit width (you need a style attribute)');
			return;
		}

		let v = value;

		// if v is blank, make sure that the text area ends up being at least one line tall
		if (!v) {
			v = 'X';
		}

		copyCSSToShadow(el);

		if (v.length && (v.charCodeAt(0) === 10 || v.charCodeAt(0) === 13)) {
			v = '_' + v;
		}

		if (v.length && (v.charCodeAt(v.length - 1) === 10 || v.charCodeAt(v.length - 1) === 13)) {
			v += '_';
		}

		const shadowElem = document.getElementById(el.dataset.shadowElemId);
		shadowElem.textContent = v;
		// set height in em units, that way student adjustments to font size won't result
		// in cut-off text
		const elStyles = getComputedStyle(el);
		const fontSize = parseFloat(elStyles.fontSize.slice(0, -2));

		const shadowStyles = getComputedStyle(shadowElem);
		const shadowHeight = parseFloat(shadowStyles.height.slice(0, -2));

		const height = shadowHeight / fontSize;
		el.style.height = `${height}em`;
	},
	unbind(el) {
		const shadowElemWrapper = document.getElementById(el.dataset.shadowElemWrapperId);

		shadowElemWrapper.remove();
	}
};
